import React from 'react'
import "../styles/Gallery.css";
import Footer from '../components/Footer';
import { useEffect, useState } from 'react';
// import { useParams } from "react-router-dom";

import AOS from 'aos';
import 'aos/dist/aos.css';

import { LazyLoadImage } from 'react-lazy-load-image-component';
// import 'react-lazy-load-image-component/src/effects/blur.css';

// Medical Rehab gallery section
import img1 from "../assets/med-rehab/img1.JPG";
import img2 from "../assets/med-rehab/img2.JPG";
import img3 from "../assets/med-rehab/img3.JPG";
import img4 from "../assets/med-rehab/img1.JPG";
import img5 from "../assets/med-rehab/img2.JPG";
import img6 from "../assets/med-rehab/img3.JPG";

// Physiotherapy gallery section
import physioImg1 from "../assets/Physiotherapy/physio-img1.JPG";
import physioImg2 from "../assets/Physiotherapy/physio-img2.JPG";
import physioImg3 from "../assets/Physiotherapy/physio-img3.JPG";
import physioImg4 from "../assets/Physiotherapy/physio-img4.JPG";
import physioImg5 from "../assets/Physiotherapy/physio-img5.JPG";
import physioImg6 from "../assets/Physiotherapy/physio-img6.JPG";

// Occupational therapy gallery section
import occImg1 from "../assets/Occupational/occ-img1.JPG";
import occImg2 from "../assets/Occupational/occ-img2.JPG";
import occImg3 from "../assets/Occupational/occ-img3.JPG";
import occImg4 from "../assets/Occupational/occ-img4.JPG";
import occImg5 from "../assets/Occupational/occ-img5.JPG";
import occImg6 from "../assets/Occupational/occ-img6.JPG";



import therapy1 from '../assets/med-rehab/img1.JPG';



const galleryData = [
  {
    title: 'Therapies',
    folder: 'med-rehab',
    images: [therapy1]
  },
  {
    title: 'Events',
    folder: 'med-rehab',
    images: ['img1.jpg', 'img2.jpg', 'img3.jpg'],
  },
  {
    title: 'Workshops',
    folder: 'med-rehab',
    images: ['img1.jpg', 'img2.jpg', 'img3.jpg'],
  },
];


const Gallery = () => {

  const [isMobile, setIsMobile] = useState(false);
  const [currentImage, setCurrentImage] = useState({});

  // useEffect(() => {
  //   AOS.init({ duration: 1000 });
  //   setIsMobile(window.innerWidth <= 768);

  //   const handleResize = () => {
  //     setIsMobile(window.innerWidth <= 768);
  //   };

  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentImage(prev => {
  //       const updated = { ...prev };
  //       galleryData.forEach(cat => {
  //         const idx = prev[cat.title] || 0;
  //         updated[cat.title] = (idx + 1) % cat.images.length;
  //       });
  //       return updated;
  //     });
  //   }, 3000);
  //   return () => clearInterval(interval);
  // }, []);


  return (
    <div>
      <section className="gallery-grid-section">
        <h2 className="gallery-heading">Medical Rehabilitation</h2>
        <div className="gallery-grid">
          <LazyLoadImage src={img1} alt="Gallery 1" />
          <LazyLoadImage src={img2} alt="Gallery 2" />
          <LazyLoadImage src={img3} alt="Gallery 3" />
          <LazyLoadImage src={img4} alt="Gallery 4" />
          <LazyLoadImage src={img5} alt="Gallery 5" />
          <LazyLoadImage src={img6} alt="Gallery 6" />
        </div>
      </section>
      
      
      <section className="gallery-grid-section">
        <h2 className="gallery-heading">Physiotherapy</h2>
        <div className="gallery-grid">
          <LazyLoadImage src={physioImg1} alt="Gallery 1" />
          <LazyLoadImage src={physioImg2} alt="Gallery 2" />
          <LazyLoadImage src={physioImg3} alt="Gallery 3" />
          <LazyLoadImage src={physioImg4} alt="Gallery 4" />
          <LazyLoadImage src={physioImg5} alt="Gallery 5" />
          <LazyLoadImage src={physioImg6} alt="Gallery 6" />
        </div>
      </section>
      
      
      <section className="gallery-grid-section">
        <h2 className="gallery-heading">Occupational Therapy</h2>
        <div className="gallery-grid">
          <img loading="lazy" src={occImg1} alt="Gallery 1" />
          <img loading="lazy" src={occImg2} alt="Gallery 2" />
          <img loading="lazy" src={occImg3} alt="Gallery 3" />
          <img loading="lazy" src={occImg4} alt="Gallery 4" />
          <img loading="lazy" src={occImg5} alt="Gallery 5" />
          <img loading="lazy" src={occImg6} alt="Gallery 6" />
        </div>
      </section>



      <Footer />
    </div>
  )
}

export default Gallery